import "./styles.css";
import { DiceBoxEngine } from "./dice/dice-box-engine";
import { canAdd, notation } from "./dice/selection";
import { DICE_TYPES, type DiceType, type RollResult } from "./dice/types";

const selection: DiceType[] = [];
const engine = new DiceBoxEngine();
const diceButtons = document.querySelector<HTMLDivElement>("#dice-buttons")!;
const selectionView = document.querySelector<HTMLDivElement>("#selection")!;
const clearButton = document.querySelector<HTMLButtonElement>("#clear")!;
const rollButton = document.querySelector<HTMLButtonElement>("#roll")!;
const resultView = document.querySelector<HTMLOutputElement>("#result")!;
const statusView = document.querySelector<HTMLParagraphElement>("#engine-status")!;
let ready = false;
let rolling = false;

function updateUi(): void {
  selectionView.textContent = notation(selection);
  clearButton.disabled = rolling || selection.length === 0;
  rollButton.disabled = rolling || !ready || selection.length === 0;
  diceButtons.querySelectorAll<HTMLButtonElement>("button").forEach((button) => {
    button.disabled = rolling || !canAdd(selection);
  });
}

function renderResult(result: RollResult): void {
  const values = result.dice.map((die) => {
    const detail = die.parts ? ` (${die.parts[0] * 10}/${die.parts[1]})` : "";
    const natural = die.type === 20 && (die.value === 1 || die.value === 20) ? ` result--nat${die.value}` : "";
    return `<span class="die-result${natural}">d${die.type}: <b>${die.value}</b>${detail}</span>`;
  }).join("");
  resultView.innerHTML = `${values}<strong class="result-total">${result.dice.length > 1 ? `Summe: ${result.total}` : ""}</strong>`;
  resultView.classList.remove("result--hidden");
}

for (const type of DICE_TYPES) {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "die-button";
  button.textContent = `d${type}`;
  button.addEventListener("click", () => {
    if (canAdd(selection) && !rolling) {
      selection.push(type);
      resultView.classList.add("result--hidden");
      updateUi();
    }
  });
  diceButtons.append(button);
}

clearButton.addEventListener("click", () => {
  selection.length = 0;
  engine.clear();
  resultView.classList.add("result--hidden");
  updateUi();
});

rollButton.addEventListener("click", async () => {
  if (rolling || selection.length === 0) return;
  rolling = true;
  resultView.classList.add("result--hidden");
  statusView.textContent = "Die Würfel rollen …";
  updateUi();
  try {
    renderResult(await engine.roll(selection));
    statusView.textContent = "Ergebnis";
    navigator.vibrate?.(18);
  } catch (error) {
    console.error(error);
    statusView.textContent = "Der Wurf konnte nicht abgeschlossen werden.";
  } finally {
    rolling = false;
    updateUi();
  }
});

void engine.initialize("#dice-box").then(() => {
  ready = true;
  statusView.textContent = "Wähle deine Würfel";
  updateUi();
}).catch((error: unknown) => {
  console.error(error);
  statusView.textContent = "3D-Würfelschale konnte nicht geladen werden.";
});

updateUi();
